import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import { localization } from '../../Frames/localization';
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export function SelectPeriod(props) {
  const classes = useStyles();
    const [state, setState] = React.useState({
        value: props.value,
      });
    const handleChange = name => event => {
      props.selectPeriod(event.target.value)
        setState({
          ...state,
          [name]: event.target.value,
        });
      };
      const inputLabel = React.useRef(null);
      const [labelWidth, setLabelWidth] = React.useState(0);
      React.useEffect(() => {
        setLabelWidth(inputLabel.current.offsetWidth);
      }, []);
        return (
            <div>
            <FormControl variant={props.variant} className={classes.formControl}>
              <InputLabel
               className={props.classNamelabel}
               ref={inputLabel} htmlFor="outlined-age-native-simple">
                {props.textLabel}
              </InputLabel>
              <Select        
                  style={props.style}     
                  className={props.className}
                  required={props.required}
                  value={props.value}
                  onChange={handleChange('value')}
                  labelWidth={labelWidth}
                  inputProps={{
                    name: 'value',
                    id: 'outlined-age-native-simple',
                  }}
                  >
                    <MenuItem classes={{root: 'ListItem', selected:'ListItemSelect'}}>-</MenuItem>
                    <MenuItem classes={{root: 'ListItem', selected:'ListItemSelect'}} value={1}>{localization.GetTranslate('Operations.beginWeek')}</MenuItem>
                    <MenuItem classes={{root: 'ListItem', selected:'ListItemSelect'}} value={2}>{localization.GetTranslate('Operations.beginMonth')}</MenuItem>
                    <MenuItem classes={{root: 'ListItem', selected:'ListItemSelect'}} value={3}>{localization.GetTranslate('Operations.previousMonth')}</MenuItem>
                    <MenuItem classes={{root: 'ListItem', selected:'ListItemSelect'}} value={4}>{localization.GetTranslate('Operations.beginYear')}</MenuItem>
                    <MenuItem classes={{root: 'ListItem', selected:'ListItemSelect'}} value={5}>{localization.GetTranslate('Operations.30days')}</MenuItem>
                    <MenuItem classes={{root: 'ListItem', selected:'ListItemSelect'}} value={6}>{localization.GetTranslate('Operations.7days')}</MenuItem>
                  }
              </Select>
              </FormControl>
            </div>
        );
    }
    export function SelectPointOfSale(props) {
      const classes = useStyles();
        const [state, setState] = React.useState({
            value: props.value,
          });
        const handleChange = name => event => {
          props.selectPointofSale(event.target.value)
            setState({
              ...state,
              [name]: event.target.value,
            });
          };
          const inputLabel = React.useRef(null);
          const [labelWidth, setLabelWidth] = React.useState(0);
          React.useEffect(() => {
            setLabelWidth(inputLabel.current.offsetWidth);
          }, []);
          const {res} = props;
            return (
                <div>
                <FormControl variant={props.variant} className={classes.formControl}>
                  <InputLabel 
                  className={props.classNamelabel}
                  ref={inputLabel} htmlFor="outlined-age-native-simple">
                    {props.textLabel}
                  </InputLabel>
                  <Select       
                      style={props.style}     
                      className={props.className}
                      required={props.required}
                      value={state.value}
                      onChange={handleChange('value')}
                      labelWidth={labelWidth}
                      inputProps={{
                        name: 'value',
                        id: 'outlined-age-native-simple',
                      }}
                      >
                        <MenuItem classes={{root: 'ListItem', selected:'ListItemSelect'}}>-</MenuItem>
                      {res &&
                        res.data.locations.map(location => (
                        <MenuItem classes={{root: 'ListItem', selected:'ListItemSelect'}} value={location.id}>{location.name}</MenuItem>
                      ))
                      }
                  </Select>
                  </FormControl>
                </div>
            );
        }
        export function SelectType(props) {
          const classes = useStyles();
            const [state, setState] = React.useState({
                value: props.value,
              });
            const handleChange = name => event => {
              props.selectType(event.target.value)
                setState({
                  ...state,
                  [name]: event.target.value,
                });
              };
              const inputLabel = React.useRef(null);
              const [labelWidth, setLabelWidth] = React.useState(0);
              React.useEffect(() => {
                setLabelWidth(inputLabel.current.offsetWidth);
              }, []);
              const {res} = props;
                return (
                    <div>
                    <FormControl variant={props.variant} className={classes.formControl}>
                      <InputLabel 
                      className={props.classNamelabel}
                      ref={inputLabel} htmlFor="outlined-age-native-simple">
                        {props.textLabel}
                      </InputLabel>
                      <Select        
                          style={props.style}     
                          className={props.className}
                          required={props.required}
                          value={state.value}
                          onChange={handleChange('value')}
                          labelWidth={labelWidth}
                          inputProps={{
                            name: 'value',
                            id: 'outlined-age-native-simple',
                          }}
                          >
                            <MenuItem classes={{root: 'ListItem', selected:'ListItemSelect'}}>-</MenuItem>
                          {res &&
                            res.data.operationTypes.map(type => (
                            <MenuItem classes={{root: 'ListItem', selected:'ListItemSelect'}} value={type.id}>{localization.GT(`Operations.` + `${type.name}`)}</MenuItem>
                          ))
                          }
                      </Select>
                      </FormControl>
                    </div>
                );
            }
            function chooseCardId(cardCode,cards)
            {
              var value = null;
              cards.map(item => {
                if(cardCode === item.code)
                {
                  value = item.externalCode;
                }
              })
              return value;
            }
            export function SelectCard(props) {
              const classes = useStyles();
              const {res} = props;
                const [state, setState] = React.useState({
                    value: chooseCardId(res.data.cardCode,res.data.cards),
                  });
                const handleChange = name => event => {
                  props.selectCard(event.target.value)
                    setState({
                      ...state,
                      [name]: event.target.value,
                    });
                  };
                  const inputLabel = React.useRef(null);
                  const [labelWidth, setLabelWidth] = React.useState(0);
                  React.useEffect(() => {
                    setLabelWidth(inputLabel.current.offsetWidth);
                  }, []);
                  
                    return (
                        <div>
                        <FormControl variant={props.variant} className={classes.formControl}>
                          <InputLabel 
                          className={props.classNamelabel}
                          ref={inputLabel} htmlFor="outlined-age-native-simple">
                            {props.textLabel}
                          </InputLabel>
                          <Select    
                              style={props.style}      
                              className={props.className}
                              required={props.required}
                              value={state.value}
                              onChange={handleChange('value')}
                              labelWidth={labelWidth}
                              inputProps={{
                                name: 'value',
                                id: 'outlined-age-native-simple',
                              }}
                              >
                              {res && 
                                res.data.cards.map(card => (
                                <MenuItem classes={{root: 'ListItem', selected:'ListItemSelect'}} value={card.externalCode}>{card.externalCode}</MenuItem>
                              ))
                              }
                          </Select>
                          </FormControl>
                        </div>
                    );
                }
    
        
    

    
